import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import 'devextreme/data/odata/store';
import DataGrid, {
  Column,
  Editing,
  Paging,
  SearchPanel,
  FilterRow,
  HeaderFilter,
  Pager,
  Scrolling,
  Summary,
  TotalItem,
  LoadPanel,
  StateStoring,
  FilterPanel,
  Selection,
  Lookup,
  Button,
  Toolbar,
  Item as ToolbarItem,
  Export
} from 'devextreme-react/data-grid';
import { Item } from 'devextreme-react/form';
// import { Item as ToolbarItem } from 'devextreme-react/toolbar';
import { useAuth } from '../../contexts/auth';
import './invoices.scss';
import axios from 'axios';
import dxDataGrid from 'devextreme/ui/data_grid';
import notify from 'devextreme/ui/notify';
import { Popup } from 'devextreme-react';
import { Button as PreviewButton } from 'devextreme-react/button'; 
import { Workbook } from 'exceljs';
import { exportDataGrid } from 'devextreme/common/export/excel';
import saveAs from 'file-saver';


export default function Invoices(bookingId: any) {
  
  const baseUrl = process.env.REACT_APP_API_URL;
  const [invoices, setInvoices] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [invoiceStatuses, setInvoiceStatuses] = useState<any[]>([]);
  const [invoiceStatusToUpdate, setInvoiceStatusToUpdate] = useState<any>();
  const [invoicesToUpdate, setInvoicesToUpdate] = useState<any[]>([]);
  const [bulkInvoiceUpdateVisible, setBulkInvoiceUpdateVisible] = useState(false);
  const [bulkInvoicePriceSum, setBulkInvoicePriceSum] = useState<string>(''); 
  const [pdfPreviewVisible, setPdfPreviewVisible] = useState(false);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [loadingPdf, setLoadingPdf] = useState(false);

  const bookingInvoicesGridRef = useRef<dxDataGrid>(null);

  const { user } = useAuth();

  useEffect(() => {
    getInvoices();
    getInvoiceStatuses();
  }, [user]);

  const getInvoices = () => {
    // if (typeof bookingId.bookingId !== 'number' || isNaN(bookingId.bookingId)) {
    //   // console.error('Invalid bookingId:', bookingId.bookingId);
    //   return;
    // }

    setLoading(true);
    axios.get(`${baseUrl}/api/Booking/bookingInvoices`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setInvoices(response.data.data))
      .catch(error => console.error('Error fetching invoices:', error))
      .finally(() => setLoading(false));
  };

  const getInvoiceStatuses = () => {
    setLoading(true);
    axios.get(`${baseUrl}/api/StaticData/invoiceStatuses`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
      .then(response => setInvoiceStatuses(response.data.data))
      .catch(error => console.error('Error fetching statuses:', error))
      .finally(() => setLoading(false));
  };

  const onInitialized = useCallback((e: any) => {
    bookingInvoicesGridRef.current = e.component;
  }, []);

  const onSaving = async(e: any) => {
    const change = e.changes?.[0];
    if (!change) return;
  
    const grid = e.component;
    const rowIndex = grid.getRowIndexByKey(change.key);
    const rowData = grid.getDataSource().items()[rowIndex];
  
    const invoiceNumber = rowData.invoiceNumber;
    const invoiceStatusName = change.data?.invoiceStatus?.name ?? rowData.invoiceStatus?.name;
    const invoiceStatusId = invoiceStatuses.find((invoiceStatus) => invoiceStatus.name === invoiceStatusName)?.id;
  
    try {
      await axios.put(`${baseUrl}/api/Booking/UpdateInvoiceStatus?invoiceNumber=${invoiceNumber}&invoiceStatusId=${invoiceStatusId}`, null, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`
        }
      }).then(() => {        
        toast('Rechnungstatus erfolgreich gespeichert', 'success')
        setInvoices((prevInvoices: any[]) =>
          prevInvoices.map(inv =>
            inv.invoiceNumber === invoiceNumber
              ? {
                  ...inv,
                  statusId: invoiceStatusId,
                  invoiceStatus: {
                    ...inv.invoiceStatus,
                    id: invoiceStatusId,
                    name: invoiceStatusName
                  }
                }
              : inv
          )
        );        
      })
      .catch(error => console.error('Rechnungstatus nicht erfolgreich gespeichert', error));   
    } catch (e: any) {
      console.error(e);
      toast('Rechnungstatus nicht erfolgreich gespeichert', e);
    }
  };

  const toast = useCallback((message: any, type: any = 'success') => {
    notify({ message: message }, type, 3000);
  }, []);

  const onSelectionChanged = (e: any) => {
    const selectedRows = e.selectedRowsData ?? [];
    if (!selectedRows || selectedRows?.length === 0) {
      setBulkInvoiceUpdateVisible(false);
      setInvoiceStatusToUpdate(0);
      setBulkInvoicePriceSum('');
      setInvoicesToUpdate([]);
      return false;
    } 
    setInvoicesToUpdate(e.selectedRowKeys);
    const count = selectedRows.length;
    setBulkInvoiceUpdateVisible(count > 0);
    const sum = selectedRows.reduce(
      (acc: any, cur: any) => acc + (isNaN(Number(cur.price)) ? 0 : Number(cur.price)),
      0 as number
    ); 
    const net = Number(sum.toFixed(2));
    const tax = Number((net * 0.19).toFixed(2));
    const total = Number((net + tax).toFixed(2));      
    const formatEUR = (v: number) => v.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); 

    setBulkInvoicePriceSum(`${formatEUR(net)}   +   Umsatzsteuer (19%) ${formatEUR(tax)}   =   ${formatEUR(total)}`);
  };

    const clearSelectionButtonOptions = useMemo(() => ({
      icon: 'close',
      text: 'Auswahl entfernen',
      onClick: () => {
        bookingInvoicesGridRef?.current?.clearSelection()
        setInvoiceStatusToUpdate(0);    
        setBulkInvoicePriceSum('');    
      },
    }), []);
  
    const bulkInvoiceUpdateButtonOptions = useMemo(() => ({
      icon: "check",
      text: "Status aktualisieren",
      onClick: async () => {
        const grid = bookingInvoicesGridRef?.current;
        if (!grid) return;
    
        const allRows = invoices;
        const selectedKeySet = new Set(invoicesToUpdate);
    
        const selectedInvoiceNumbers = Array.from(
          new Set(
            allRows
              .filter((r: any) => selectedKeySet.has(r.id))
              .map((r: any) => r.invoiceNumber)
          )
        );
    
        if (!selectedInvoiceNumbers.length) return;
    
        // 🔑 resolve status once
        const selectedStatus = invoiceStatuses.find(
          (s: any) => s.id === invoiceStatusToUpdate
        );
    
        if (!selectedStatus) {
          toast('Ungültiger Rechnungsstatus', 'error');
          return;
        }
    
        const invoiceStatusName = selectedStatus.name;
    
        for (const invoiceNumber of selectedInvoiceNumbers) {
          try {
            await axios.put(
              `${baseUrl}/api/Booking/UpdateInvoiceStatus?invoiceNumber=${invoiceNumber}&invoiceStatusId=${invoiceStatusToUpdate}`,
              null,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('authToken')}`,
                },
              }
            );
    
            toast('Rechnungstatus erfolgreich gespeichert', 'success');
            bookingInvoicesGridRef?.current?.clearSelection();
    
            setInvoices((prevInvoices: any[]) =>
              prevInvoices.map((inv) =>
                inv.invoiceNumber === invoiceNumber
                  ? {
                      ...inv,
                      statusId: invoiceStatusToUpdate,
                      invoiceStatus: {
                        ...inv.invoiceStatus,
                        id: invoiceStatusToUpdate,
                        name: invoiceStatusName, // ✅ correct name
                      },
                    }
                  : inv
              )
            );
          } catch (error) {
            console.error('Rechnungstatus nicht erfolgreich gespeichert', error);
            toast('Rechnungstatus nicht erfolgreich gespeichert', 'error');
          }
        }
      },
    }), [invoiceStatusToUpdate, invoiceStatuses]);    
    
    const onExporting = (e: any) => {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('invoices');
      exportDataGrid({
          component: e.component,
          worksheet: worksheet,
          customizeCell: function(options) {
              options.excelCell.font = { name: 'Arial', size: 12 };
              options.excelCell.alignment = { horizontal: 'left' };
          } 
      }).then(function() {
          workbook.xlsx.writeBuffer()
              .then(function(buffer) {
                  saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'InnKep-invoices.xlsx');
              });
      });
    }
    
  const openPdfPreview = async (invoiceNumber: string) => {
    try {
      setLoadingPdf(true);
  
      const response = await axios.get(`${baseUrl}/api/Blob/downloadInvoice?fileName=${invoiceNumber}`, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      });
  
      const blob = new Blob([response.data], { type: "application/pdf" });
      const objectUrl = URL.createObjectURL(blob);
  
      setPdfUrl(objectUrl);
      setPdfPreviewVisible(true);
    } catch (err) {
      console.error("Failed to load PDF", err);
      toast("PDF konnte nicht geladen werden", "error");
    } finally {
      setLoadingPdf(false);
    }
  };    

  const rowPrepared = (e: any) => {
    
    if (e.rowType === "data") {
      // console.log(e.data);
      // if (e.data.invoiceStatus.name === 'Bezahlt') {
      //   e.rowElement.classList.add("bezahlt-invoice-row");
      //   e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
      //   // console.log(e);
      // }
      switch(e.data.invoiceStatus.name) {
        case 'Bezahlt':
          e.rowElement.classList.add("bezahlt-invoice-row");
          e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
          break;
        case 'Storniert':
          e.rowElement.classList.add("storniert-invoice-row");
          e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
          break;
        case 'Zahlungserinnerung':
          e.rowElement.classList.add("zahlungserinnerung-invoice-row");
          e.rowElement.className = e.rowElement.className.replace("dx-row-alt", "");
          break;
        default:
          // e.cellElement.style.cssText = "text-align: center; font-weight: 500; background-color:rgb(227, 233, 235)";
      }
    }
  };

  return (
    <React.Fragment> 
      <Popup
        visible={pdfPreviewVisible}
        onHiding={() => {
          if (pdfUrl) URL.revokeObjectURL(pdfUrl); // cleanup
          setPdfUrl(null);
          setPdfPreviewVisible(false);
        }}
        title="Rechunngsvorschau"
        width="80vw"
        height="90vh"
        showCloseButton
      >
        {loadingPdf && <div>PDF wird geladen…</div>}

        {!loadingPdf && pdfUrl && (
          <>
            {/* Toolbar */}
            <div style={{ textAlign: "right", marginBottom: 8 }}>
              <Button
                icon="download"
                text="Download"
                onClick={() => window.open(pdfUrl)}
              />
            </div>

            {/* PDF */}
            <iframe
              src={pdfUrl}
              style={{ width: "100%", height: "100%", border: "none" }}
              title="Invoice PDF"
            />
          </>
        )}
      </Popup>     
      <h2>Rechnungen </h2>
      <DataGrid
        className={'dx-card content-block dx-datagrid-compact'}
        dataSource={invoices}
        keyExpr="id"
        focusedRowEnabled={true}
        defaultFocusedRowIndex={0}
        showBorders={true}
        columnAutoWidth={true}
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnResizingMode="widget"
        showColumnLines={true}
        showRowLines={true}
        rowAlternationEnabled={true}
        columnHidingEnabled={true}
        onInitialized={onInitialized}
        onRowPrepared={rowPrepared}
        onSelectionChanged={onSelectionChanged}
        onExporting={onExporting}
        onSaving={onSaving}
        repaintChangesOnly={true}>
        <LoadPanel enabled={true} showIndicator={loading}/>
        <SearchPanel visible={true} width={240} placeholder="Search..." />
        <FilterRow visible={true} />
        <HeaderFilter visible={true} />
        {/* <GroupPanel visible={false} /> */}
        {/* <ColumnChooser enabled={true} mode='select' height={'600'}/> */}
        <StateStoring enabled={true} type="localStorage" storageKey="innkepInvoiceGridState" />
        <FilterPanel visible={true} />
        <Export enabled={true} />
        <Selection mode="multiple" showCheckBoxesMode="always" />
        <Toolbar>       
          <ToolbarItem
            location="before"
            widget="dxButton"
            options={{
              icon: clearSelectionButtonOptions.icon,
              text: clearSelectionButtonOptions.text,
              visible: bulkInvoiceUpdateVisible,
              onClick: clearSelectionButtonOptions.onClick
            }}
          />
          {/* <ToolbarItem location="after" visible={bulkInvoiceUpdateVisible}>Total</ToolbarItem> */}
          <ToolbarItem
            location="before"
            widget="dxTextBox"        
            visible={bulkInvoiceUpdateVisible}
            options={{
              readOnly: true,
              label: 'Summe',
              labelMode: 'static',
              width: 400,
              value: `${bulkInvoicePriceSum}`          
            }}
          />
          <ToolbarItem
            location="after"
            widget="dxSelectBox"
            visible={bulkInvoiceUpdateVisible}
            options={{
              dataSource: invoiceStatuses,
              valueExpr: 'id',
              displayExpr: 'name',
              value: invoiceStatusToUpdate,
              onValueChanged: (e: any) => {
                setInvoiceStatusToUpdate(e.value) }             
            }}
          />
          <ToolbarItem
            location="after"
            widget="dxButton"
            options={{
              icon: bulkInvoiceUpdateButtonOptions.icon,
              text: bulkInvoiceUpdateButtonOptions.text,
              visible: bulkInvoiceUpdateVisible,
              disabled: !invoiceStatusToUpdate,
              onClick: bulkInvoiceUpdateButtonOptions.onClick
            }}
          />        
          <Item name="exportButton" />
          <Item name="searchPanel" />
        </Toolbar>
        <Paging defaultPageSize={50} />
        <Pager
          showPageSizeSelector={true}
          visible={true}
          allowedPageSizes={[25, 50, 100]}
          showInfo={true}
        />
        <Summary>
          <TotalItem column="invoiceNumber" summaryType="count" />
        </Summary>
        <Editing
          refreshMode={'repaint'}
          mode="row"
          useIcons={true}
          allowUpdating={true}
          allowDeleting={false}
          allowAdding={false}
          texts={{ confirmDeleteMessage: '' }}>
        </Editing>
        {/* <FilterRow visible={true} /> */}
        <Scrolling mode="standard" />
        <Scrolling useNative={true} showScrollbar="always" />

        <Column dataField="id" sortIndex={0} sortOrder="desc" visible={false} allowEditing={false}/>
        <Column dataField="invoiceNumber" caption="Rechnungsnummer" allowEditing={false}/> 
        <Column dataField="bookingId" caption="BookingId" allowEditing={false}/> 
        <Column dataField="companyName" caption="Firma" allowEditing={false}/> 
        <Column dataField="type" caption="Typ" allowEditing={false}
          calculateCellValue={(data: any) => ((data.price >= 0) ? `Rechnung` : `Stornorechnung`)}
        />  
        <Column dataField="price" caption="Preis" allowEditing={false}/>
        <Column dataField="invoiceStatus.name" caption="Status" allowEditing={true}>  
          <Lookup dataSource={invoiceStatuses} displayExpr="name" valueExpr="name" />
        </Column>
        <Column dataField="refInvoiceNumber" caption="Referenzrechnungsnummer" visible={false} allowEditing={false}/>  
        <Column dataField="createdDate" caption="Erstellet am" dataType="date" format="dd.MM.yyyy" allowEditing={false}/>
        <Column dataField="updatedDate" caption="Aktualisiert am" dataType="date" format="dd.MM.yyyy" allowEditing={false} />
        <Column caption="Vorshau" allowEditing={false}
          cellRender={(cellData) => (
            <PreviewButton text="" icon="eyeopen" stylingMode="outlined"
              onClick={() => openPdfPreview(cellData.data.invoiceNumber)}
            />
          )}
        />
      </DataGrid>      
    </React.Fragment>
)}